import { render, staticRenderFns } from "./exhibitionOverview.vue?vue&type=template&id=e05140a4&scoped=true"
import script from "./exhibitionOverview.vue?vue&type=script&lang=js"
export * from "./exhibitionOverview.vue?vue&type=script&lang=js"
import style0 from "./exhibitionOverview.vue?vue&type=style&index=0&id=e05140a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e05140a4",
  null
  
)

export default component.exports